/* eslint-disable no-console */
import {
  createStore,
  compose,
  applyMiddleware,
  Reducer,
  Middleware,
} from 'redux';

const create = (reducers: Reducer, middlewares: Middleware[]) => {
  const enhancer =
    process.env.NODE_ENV === 'development'
      ? compose(console.tron.createEnhancer(), applyMiddleware(...middlewares))
      : applyMiddleware(...middlewares);

  return createStore(reducers, enhancer);
};

export { create };
